<template>
  <div>
    <div class="child-quote-list">
      <div class="header row">
        <div></div>
        <div>{{ i18n.t('/AdditionalOrder/QuoteNumberLabel') }}</div>
        <div>{{ i18n.t('/AdditionalOrder/StatusLabel') }}</div>
      </div>
      <ul>
        <li
          v-for="childQuote in childQuotes"
          :key="childQuote.QuoteId"
          class="row"
          :data-qa="`open-child-quote-${childQuote.QuoteId}`"
          @click="openAdditionalOrderModal(childQuote.QuoteId)"
        >
          <a>
            {{ additionalQuoteLinkText(childQuote.CreatedOn) }}
          </a>
          <div>{{ childQuote.QuoteId }}</div>
          <div>{{ childQuote.FormattedStatus }}</div>
        </li>
        <li
          v-for="linkedChangeOrder in linkedChangeOrders"
          :key="linkedChangeOrder.ChangeOrderId"
          class="row"
          :data-qa="`open-linked-change-order-${linkedChangeOrder.ChangeOrderId}`"
          @click="openLinkedChangeOrder(linkedChangeOrder.ChangeOrderId)"
        >
          <a>
            {{ linkedChangeOrderLinkText(linkedChangeOrder.CreatedOn) }}
          </a>
          <div>{{ linkedChangeOrder.ChangeOrderId }}</div>
          <div>{{ linkedChangeOrder.StatusDescription }}</div>
        </li>
      </ul>
    </div>
    <modal
      v-if="showAdditionalOrderModal"
      :title="i18n.t('/AdditionalOrder/AdditionalOrder')"
      :extra-wide="true"
      class="modal"
      @close="toggleAdditionalOrderModal(false)"
    >
      <additional-order-modal
        :child-quote-id="selectedChildQuoteId"
        @close="toggleAdditionalOrderModal(false)"
      ></additional-order-modal>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import AdditionalOrderModal from '@/components/generic/container/additionalOrderBlock/AdditionalOrderModal.vue'
import moment from 'moment'

import { EventBus } from '@/plugins/event-bus'

export default {
  components: {
    AdditionalOrderModal,
    Modal,
  },
  props: {
    childQuotes: {
      type: Array,
      default: null,
    },
    linkedChangeOrders: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      selectedChildQuoteId: null,
      showAdditionalOrderModal: false,
    }
  },
  created() {
    EventBus.$on('open-additional-order-modal', this.openAdditionalOrderModal)
  },
  unmounted() {
    EventBus.$off('open-additional-order-modal', this.openAdditionalOrderModal)
  },
  methods: {
    openAdditionalOrderModal(childQuoteId = null) {
      this.selectedChildQuoteId = childQuoteId?.toString()
      this.toggleAdditionalOrderModal(true)
    },
    openLinkedChangeOrder(changeOrderId) {
      let params = {
        ...this.$route.params,
        changeOrderId: changeOrderId,
        establishmentId: this.$route.params.establishmentId,
      }

      this.$router.push({ name: 'change-order-page', params })
    },
    toggleAdditionalOrderModal(show) {
      if (!show) {
        this.selectedChildQuoteId = null
      }
      this.showAdditionalOrderModal = show
    },
    formatDate(date) {
      return moment.utc(date).format('DD MMMM YYYY')
    },
    additionalQuoteLinkText(createdOnDate) {
      return this.i18n.t('/additionalorder/additionalorderfrom', {
        createdOnDate: this.formatDate(createdOnDate),
      })
    },
    linkedChangeOrderLinkText(createdOnDate) {
      return this.i18n.t('/quote/changeorder/changeorderlinktext', {
        createdOnDate: this.formatDate(createdOnDate),
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.row {
  padding: 0.5rem;
  border-bottom: 1px solid #dae2e5;
  display: grid;
  grid-column-gap: 0.5rem;
  grid-template-columns: auto 10em 8em;
  grid-template-areas:
    'title quote-number status'
    'col col col';

  &.header {
    background-color: #f1f4f5;
    font-weight: 700;
  }
}

li.row {
  list-style-type: none;
}
</style>
